import { render } from "./modal-success.template.html?vue&type=template&id=221bb01f&scoped=true"
import script from "./ModalSuccess.vue?vue&type=script&lang=ts"
export * from "./ModalSuccess.vue?vue&type=script&lang=ts"

import "./ModalSuccess.vue?vue&type=style&index=0&id=221bb01f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-221bb01f"

export default script